<template>
  <main
    class="grid min-h-screen w-full place-items-center px-6 py-24 sm:py-32 lg:px-8"
  >
    <div class="text-center">
      <p class="text-7xl font-semibold text-secondary">404</p>
      <h1
        class="mt-4 text-3xl font-bold tracking-tight text-primary sm:text-5xl"
      >
        Page not found
      </h1>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <router-link
          to="/"
          class="rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-black shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >Go back home</router-link
        >
        <!-- <a href="#" class="text-sm font-semibold text-gray-900"
          >Contact support <span aria-hidden="true">&rarr;</span></a
        > -->
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'ErrorPage',
};
</script>

<style></style>
